import { Icon20GovernmentOutline, Icon20Hearts2Outline, Icon20SmileAddOutline } from '@vkontakte/icons';
import { Headline, Spacing } from '@vkontakte/vkui';
import image from 'img/family-by-option/img.png';
import React, { type RefObject, forwardRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { isRebrandingQuotaLanding } from 'reactApp/appHelpers/featuresHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import type { FamilyByOptionTooltipProps } from 'reactApp/sections/QuotaLanding/FamilyByOptionTooltip/FamilyByOptionTooltip.types';
import { sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FamilyByOptionTooltip.css';

const sendRadar = (action: 'show' | 'close') => {
    sendDwh({ eventCategory: 'family-option-tooltip', action });
    sendQuotaGa({ action: 'tooltip-family-option', label: action });
};

export const FamilyByOptionTooltip = forwardRef<HTMLDivElement, FamilyByOptionTooltipProps>(
    ({ onClose, leftOffset, placement = ETooltipPlacement.topEnd, closeOnOutsideClick = true }, ref) => {
        const dispatch = useDispatch();
        const isMobile = EnvironmentSelectors.isMobile();

        const handleOnShow = useCallback(() => {
            sendRadar('show');
        }, [dispatch]);

        const handleClose = useCallback(() => {
            onClose?.(false);
            sendRadar('close');
        }, [onClose]);

        return (
            <FloatingTooltip
                target={ref as RefObject<HTMLDivElement>}
                placement={placement}
                appearance={ETooltipAppearance.blueLight}
                size={ETooltipSize.fit}
                onShow={handleOnShow}
                onClose={handleClose}
                allowFlip={false}
                qaId="family-option-tooltip"
                usePortal
                belowSticky
                isRebrandingQuotaLanding={isRebrandingQuotaLanding}
                contentClassName={styles.content}
                leftOffset={leftOffset}
                closeOnOutsideClick={closeOnOutsideClick && !isMobile}
            >
                <div className={styles.root}>
                    <Headline weight="1" className={styles.title}>
                        Делитесь гигабайтами
                        <br />и функциями с близкими
                    </Headline>
                    <Spacing size={10} />
                    <div className={styles.textWrap}>
                        <div className={styles.item}>
                            <Icon20SmileAddOutline width={16} height={16} />
                            <span>Добавление ещё 3 участников</span>
                        </div>
                        <div className={styles.item}>
                            <Icon20Hearts2Outline width={16} height={16} />
                            <span>Семейные папки и альбомы </span>
                        </div>
                        <div className={styles.item}>
                            <Icon20GovernmentOutline width={16} height={16} />
                            <span>Распознавание документов семьи</span>
                        </div>
                    </div>
                    <img src={image} className={styles.image} alt="Люди" />
                </div>
            </FloatingTooltip>
        );
    }
);

FamilyByOptionTooltip.displayName = 'FamilyByOptionTooltip';
